import React from "react";
import { spacing } from "./theme";
import styled from "styled-components";
import { ProgramContainer } from "./entities/formTemplateDataType";
import SurveyComponent from "./runtimeComponent/subComponent/SurveyComponent";
import FeedbackComponent from "./runtimeComponent/subComponent/FeedbackComponent";
import { FeedbackStatus } from "./entities/Constants";
import { getEnvVar } from "./config/RuntimeConfig";

const FormBody = styled.div`
    margin-top: ${spacing.spacing4};

    p {
        font-size: 22px;
        line-height: 35px;
    }
`;

interface Props {
    isEng: boolean;
    programContainer: ProgramContainer
}

export class SessionEndComponent extends React.Component<Props> {

    constructor(props: Props) {
        super(props);

    }

    render() {
            // let feedbackUrl;
            const profile = this.props.programContainer.Profile;

            // if (profile==null || profile==undefined) {
            //     feedbackUrl = this.props.isEng ? process.env.FEEDBACK_URL_NO_CXP_USER : process.env.FEEDBACK_URL_NO_CXP_USER_F;
            //  } else {
            //     feedbackUrl = this.props.isEng ? process.env.FEEDBACK_URL_CXP_USER : process.env.FEEDBACK_URL_CXP_USER_F;
            // }
    
            // const showYourfeedback = this.props.isEng ? `<a href=${feedbackUrl} rel="noopener noreferrer" target="_blank">Share your feedback</a>` :
            //     `<a href=${feedbackUrl} rel="noopener noreferrer" target="_blank">Faites-nous part de vos commentaires</a>`;
        return (
            <FormBody>
                <div>
                    <span className="ontario-h1">{this.props.isEng ? "Your session has ended" :
                        "La demande de renouvellement de la carte Santé de votre enfant n’a pas été acceptée."}</span>
                </div>
                <p></p>
                <div>
                    <span>{this.props.isEng ? "You have reached 20 minutes of inactivity or have canceled your session" :
                        "Nous rencontrons un problème technique avec notre système"}</span>
                </div>
                <p></p>

                <div>
                    <span>{this.props.isEng ? "To protect your privacy, we've deleted your information and signed you out of your account."
                        : "Pour protéger votre vie privée, nous avons supprimé vos informations et vous avons déconnecté de votre compte."}</span>
                </div>
                <p></p>
                <div>
                    <div>
                        <button className="ontario-button ontario-button--primary" onClick={() => {
                            if (this.props.programContainer.Profile)
                                window.location.replace(this.props.isEng ? getEnvVar('CXP_URL') : getEnvVar('CXP_URL_F'));
                            else
                                window.location.replace(this.props.isEng ? getEnvVar('SERVICEONTARIO_URL') : getEnvVar('SERVICEONTARIO_URL_F'));
                        }}>
                            {this.props.isEng ? "Start a new session" : "Commencer une nouvelle session"}
                        </button>
                    </div> <p></p>
                    {/* <div>
                        <SurveyComponent programContainer={this.props.programContainer} isEng={this.props.isEng} ></SurveyComponent>
                    </div> */}
                    <div>
                        <FeedbackComponent programContainer={this.props.programContainer} isEng={this.props.isEng} status={FeedbackStatus.Failed}></FeedbackComponent>
                    </div>
                </div>

            </FormBody>
        )

    }
}